import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{staticClass:"text-uppercase font-weight-bold",class:`status_${_vm.status}`,attrs:{"small":"","label":""}},[_vm._v(" "+_vm._s(_vm.status === 0 ? _vm.$t('alert_case_details.table.headers.status.options.pending') : (_vm.status === 1 ? _vm.$t('alert_case_details.table.headers.status.options.true') : _vm.$t('alert_case_details.table.headers.status.options.false')))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }